<template>
  <div class="listings-table">
    <t-datatable
     
      class="table"
      @selectedChanged="selectedChanged"
      :dataKey="'customerListings'"
      :actions="{
        get: getListings,
        delete: 'delete',
      }"
      :emptyData="{
        show: true,
        imgSrc: $config.noListings,
        message: 'You have no listings yet...',
        showButton: true,
        label: 'Add New Listing',
        function: openSellPopup
      }"
      :config="{
        multiple: true,
        addNewSettings: {
          function: addNew,
        },
        editSettings: { function: edit },
        columns: [
          { title: 'Id', keys: ['id'], style: 'ID', custom: viewId,},
          // { title: 'Action', custom: viewKit, click: openKit, style: 'width:90px;', },
          { title: 'Thumb', keys: ['thumb_url'], custom: viewImage },
          { title: 'Status', custom: viewStatus },
          { title: 'title', keys: ['title'], click: openKit, custom:title},
          // { title: 'brand', keys: ['brandName'], style: 'width:85px;', },
          // { title: 'category', keys: ['categoryName'], style: 'width:100px;', },
          // { title: 'product', keys: ['productName'] , style: 'width:90px;',},
          // { title: 'model Nb.', keys: ['modelNumber'], style: 'width:80px;', },
          // { title: 'condition', keys: ['conditionName'], style: 'width:75px;', },
          { title: 'price', custom: viewPrice },
          {title: 'quantity', keys:['quantity']},
          // { title: 'year', keys: ['itemYear'], style: 'width:75px;', },
          { title: 'created at', keys: ['createdAt']},
          {
            title: 'Nb Of Views',
            custom: nbViews, 
            style:'text-align: center',
          },
          { title: 'Requests', custom: renderMatchingRFPs, click:openDialog },
          // {
          //   title: 'View',
          //   click: openKit,
          //   custom: viewIcon,
          // },
        ],
      }"
      ref="childtable"
    >
    </t-datatable>
  </div>
  <div class="confirmpopup" v-if="kitConfirmed.show">
    <span style="float: right; cursor: pointer; font-weight: bold" @click="hideDropdown"
      >x</span
    ><br />
    <span v-if="kitConfirmed.value" style="color: green"> Availability confirmed </span>
    <span v-else style="color: red">
      Availability is not confirmed. Click the button to confirm availabilities for 7 days
    </span>
    <br />
    <br />
    <template v-if="!kitConfirmed.value">
      <t-button
        :icon="'pi pi-check'"
        :label="'Confirm availability'"
        @click="confirmAvailability"
      />
    </template>
    <br />
  </div>

  <Dialog v-model:visible="dialog_open" :modal="true" position="center" style="width: 90%">
        <MatchRequests :kitId="kitId"/>
  </Dialog>
</template>

<script>
// import TDatatable from "../../../../common/components/datatable/TDatatable.vue";
import { TOGGLE_AUTH_POPUP } from "../../../../domains/authentication/store/actions";
import { defineAsyncComponent } from "vue";
const TDatatable = defineAsyncComponent(() =>
  import("../../../../common/components/datatable/TDatatable.vue")
);
import {
  DELETE_CUSTOMER_LISTING,
  GET_CUSTOMER_LISTINGS,
  UPDATE_STATUS,
} from "../../store/listing/actions";
import store from "../../../../store";
import TButton from "../../../../common/components/buttons/TButton.vue";
import {
  SELL_SET_EDIT_MODE,
  SELL_SET_KIT_ID,
  SWITCH_SELL_FORM,
} from "../../../sell/store/actions";
import { reactive } from "@vue/reactivity";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import GeneralHelper from "../../../../common/helpers/GeneralHelper";
import Dialog from "primevue/dialog";
import MatchRequests from "../../../../common/components/kits/MatchRequests.vue";
export default {
  components: { TDatatable, TButton, Dialog, MatchRequests },
  data()
  {
      return {
          dialog_open: false,
          kitId:null
      }
  },
  methods: {
    openDialog(data)
    {
        this.kitId = data.id
        this.dialog_open = true
    },
    selectedChanged(event) {
      this.$emit("selectedChanged", event);
    },
    renderMatchingRFPs(data){
        if (data.is_approved)
          return "<div style='cursor:pointer; padding: 5px; border: 1px solid var(--app-secondary-color); background: transparent; color:var(--app-secondary-color); font-weight:500; font-size:12px; border-radius: 4px; text-align: center;'><span>View Matches</span></div>";
        else return ""
    },

    async openSellPopup() {
      if (this.$store.getters.isAuthenticated) {
        let getListings = await this.$store.dispatch(GET_CUSTOMER_LISTINGS);
        if (getListings.length > 0) {
          this.$router.push({ name: "sell" });
        } else {
          this.$router.push({ name: "how-it-works-sell" });
        }
      } else {
        this.$store.dispatch(TOGGLE_AUTH_POPUP, true);
        // await this.openSellPopup()
      }
    },
  },
  setup() {
    const router = useRouter();
    let getListings = GET_CUSTOMER_LISTINGS;

    

    let edit = (id) => {
      store.dispatch(SWITCH_SELL_FORM);
      store.dispatch(SELL_SET_KIT_ID, id);
      store.commit(SELL_SET_EDIT_MODE, true);
    };
    const childtable = ref(null);

    const unselectData = () => {
      childtable.value.unselectSelectedData();
    };

    let kitConfirmed = reactive({
      value: false,
      show: false,
      kitId: undefined,
    });

    const viewKit = () => {
      return "<span style='cursor:pointer; color:blue'>View Item</span>";
    };

    const nbViews = (data) => {
      console.log(data)
      return data.views;
    };

    const viewId = (data) => {
      return (
        "<span style='cursor:pointer; font-weight:600'>#" + GeneralHelper.pad(data.id, 5) + "</span>"
      );
    };

    const title = (data) => {
      let result ="<span style='cursor:pointer;text-decoration:underline; font-weight:600'>"+ data.title +"</span>";
      return result;
    };

    const viewImage = (data) => {
      if (data.fileTypeId == 3)
      return `<video 
              style='min-width:50px !important; width:50px !important; '
              autoplay
              muted
              loop
              >
              <source src="${data.thumb_url}"">
            </video>`
      return "<img style='min-width:50px !important; width:50px !important; ' src='" + data.thumb_url + "'/>";
    }

    const confirmAvailability = () => {
      store.dispatch(UPDATE_STATUS, kitConfirmed.kitId).then(() => {
        store.getters.customerListings.forEach((element) => {
          if (element.id == kitConfirmed.kitId) {
            (element.availabilityId = 4), (kitConfirmed.show = false);
          }
        });
      });
    };

    const viewIcon = () => {
      return "<span style='cursor:pointer; color:back; width:15px; '><i class='pi pi-eye'></i></span>";
    };

    const openConf = (data) => {
      if (data.availabilityId == 1) return;
      kitConfirmed.show = true;
      kitConfirmed.value = data.availabilityId != 4 ? false : true;
      kitConfirmed.kitId = data.id;
    };

    const hideDropdown = () => {
      kitConfirmed.show = false;
    };
    const viewPrice = (data) => {
      var price = data.currencyCode + " " + data.cprice
      var salesPrice = data.currencyCode + " " + data.salesCprice
      if(data.cprice == data.salesCprice) return price
      else return "<span style= 'color:grey;text-decoration: line-through;'>"+ price +" </span> <br> <span>"+ salesPrice +"  </span>"
     
    };

    const deleteKit = (data) => {
      store.dispatch(DELETE_CUSTOMER_LISTING, data);
    };

    const viewStatus = (data) => {
      var av =
        '<svg style="cursor:pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986" stroke="#52C41A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 4L12 14.01L9 11.01" stroke="#52C41A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var nav =
        '<svg style="cursor:pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#FB4E4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 8V12" stroke="#FB4E4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 16H12.01" stroke="#FB4E4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      if (data.is_draft == 1) return "Draft";
      if (data.is_approved == 0) return "Pending";
      if (data.is_approved == 2) return "Rejected";
      else if (data.availabilityId == 1) return "Sold";
      else {
        if (data.availabilityId == 2 || data.availabilityId == 3)
          return "UNPUBLISHED" + "&nbsp;&nbsp;" + nav;
        else return "Live" + "&nbsp;&nbsp;" + av;
      }
    };

    const openKit = (data) => {
      //store.dispatch("displayProductDetails1", { option: true, id: data.id });
      router.push({
        name: "kitDisplayLink",
        params: {
          id: data.id,
          brand: data.brandName,
          category: data.categoryName,
        },
      });
    };

    let addNew = () => {
      store.dispatch(SWITCH_SELL_FORM);
    };

    return {
      title,
      childtable,
      unselectData,
      getListings,
      edit,
      addNew,
      viewKit,
      openKit,
      hideDropdown,
      viewStatus,
      openConf,
      confirmAvailability,
      viewPrice,
      kitConfirmed,
      deleteKit,
      viewIcon,
      viewId,
      viewImage,
      nbViews,
    };
  },
};
</script>

<style lang="scss" scoped>
.confirmpopup {
  max-width: 600px;
  width: 90%;
  position: fixed;
  top: 50%;
  background: white;
  left: calc(50% - 150px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  padding: 5px;
}
.table {
  width: calc(100vw - 350px) !important;
  max-width: 1600px;
  //min-width: 1000px;
  overflow: scroll;
  margin: auto;
  @media screen and (max-width: 1050px) {
    width: calc(100vw - 0px) !important;
    min-width: unset;
    
  }
}
</style>
